<template>
  <div class="box">
    <div class="shadow"></div>
    <div class="loginMsg">
      <p>我的奖品</p>
      <ul class="myGoods">
        <li v-for="item in list" :key="item.drawId">
          <p class="goods">{{item.prize}}</p>
          <p class="msg">{{handleState(item)}}</p>
          <p class="time">{{item.ctime}}</p>
          <div class="btnPosition" v-if="item.status==0" @click="getPrize(item)">
            <Button bgcolor="#d250ee">领取</Button>
          </div>
          <!-- <div class="btnPosition" v-if="item.status==1 && item.type=='SW' || item.status==1 && item.type=='QB'" @click="getPrize(item)">
            <Button bgcolor="#d250ee">修改</Button>
          </div> -->
        </li>
      </ul>
      <div class="cancel" @click="()=>{this.$emit('cancle')}"></div>
    </div>
    <Bingo
      v-if="open.Bingo"
      :title="title"
      @cancle="()=>{this.getList();this.open.Bingo=!this.open.Bingo}"
    />
  </div>
</template>

<script>
/* eslint-disable */
import Button from "../common/Button";
import Bingo from "../common/Bingo";
import {my_prize} from '../../utils/config'
export default {
  components: {
    Button,
    Bingo
  },
  data: () => ({
    list: [],
    id: 0,
    open: {
      Bingo: false
    },
    title: ""
  }),
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.$axios({
        method: "get",
        withCredentials: true,
        crossDomain: true,
        url:my_prize
      }).then(res => {
        let { data } = res;
        if (data.code == 0) {
          data.data.sort((a,b)=>{
            return new Date(b.ctime).getTime() - new Date(a.ctime).getTime();
          })
          this.list = data.data;
        }
      });
    },
    getPrize(item) {
      if (item.type == "QB" || item.type == "SW") {
        this.$emit("cancle", item);
      } else {
        this.$axios({
          method: "get",
          withCredentials: true,
          crossDomain: true,
          url: "http://106.15.170.130/dnf/rest/award",
          params: {
            drawId: item.drawId
          }
        }).then(res => {
          let { data } = res;
          if (data.code == 0) {
            this.open.Bingo = true;
            this.title = data.msg;
          }
        });
      }
    },
    handleState(item) {
      if (item.type == "SW" || item.type == "QB") {
        return item.status == 0 ? "未领取" : item.address;
      } else {
        return item.status == 0 ? "未领取" : "已领取";
      }
    }
  }
};
</script>

<style scoped lang="scss">
.box {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;

}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.shadow {
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.5;
}
.loginMsg {
  position: absolute;
  border-radius: 10px;
  left: 50%;
  top: 20%;
  transform: translateX(-50%);
  width: 660px;
  text-align: center;
  font-size: 30px;
  background: #fff;
  z-index: 99999;
  padding: 35px 35px 0;
  .myGoods {
    margin-top: 40px;
    height: 495px;
    overflow-y: scroll;
    li {
      position: relative;
      margin-bottom: 10px;
      height: 120px;
      border-bottom: 1px solid #e1e1e1;
      text-align: left;
      .goods {
        font-size: 30px;
        margin-bottom: 12px;
      }
      .msg {
        font-size: 23px;
        margin-bottom: 14px;
      }
      .time {
        font-size: 18px;
        color: #868686;
      }
      .btnPosition {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 14px;
      }
    }
  }
}
.cancel {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  bottom: -100px;
  height: 48px;
  width: 48px;
  background: url("../assets/guanbi.png") no-repeat;
  background-size: 100% 100%;
}
</style>
